import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { permissionGuard } from '@adornis/user-forms/permission-guard.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { ANY_CONTEXT } from '@adornis/users/db/a-roles.js';
import { ChromiumDialog } from '@chancenwerk/client/design/components/cr-dialog.js';
import '@chancenwerk/components/chancen-component-context-menu.js';
import '@chancenwerk/components/notifications/chancen-component-notification-list.js';
import { ChancenPermission } from '@chancenwerk/db/permissions.js';
import '@chancenwerk/design/components/cr-icon.js';
import { type ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { CWPollEditor, POLL_ALLOWED_FIELDS } from '@chancenwerk/poll/client/cw-poll-editor.js';
import { PollLink } from '@chancenwerk/poll/entities/PollLink.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../components/campus-component-section-lesson-list.js';
import './campus-page-no-permission.js';

@customElement('campus-page-administration-poll-management')
export class CampusAdministrationPollManagement extends ChemistryLitElement {
  @state() private readonly _currentUser = new RXController(this, currentUser<ChancenwerkUser>());
  @state() private readonly _size = new WindowSizeController(this);

  override styles = () => [
    {
      ':host': {
        // height: '100%',
        width: '100%',
      },
    },
  ];

  override render() {
    return permissionGuard(ChancenPermission.campus.EDIT_POLLS, () => this._content(), {
      forbiddenTemplate: html`<campus-page-no-permission></campus-page-no-permission>`,
      context: ANY_CONTEXT,
    });
  }

  private _content() {
    return html`
      <cr-flex padding="${this._size.mobile ? 'md' : 'lg'}" space="lg">
        <cr-flex horizontal space-between>
          <cr-flex space="lg">
            <cr-h2> Wirkungsmessung </cr-h2>
            <cr-text> Hier kannst du Umfragen für die Wirkungsmessung mit LamaPoll verknüpfen. </cr-text>
          </cr-flex>
          <chancen-component-context-menu
            .items=${[
              {
                icon: 'add',
                label: 'Hinzufügen',
                action: async () => {
                  ChromiumDialog.showPopup<void>({
                    content: resolve => {
                      return html`<cr-flex padding="lg">
                        ${CWPollEditor({
                          onDone: async () => resolve(),
                        })}
                      </cr-flex>`;
                    },
                  });
                },
              },
            ]}
          ></chancen-component-context-menu>
        </cr-flex>

        <cr-flex space="lg">
          <cr-data-view
            .options=${{
              class: PollLink,
              selectionSet: {
                studentType: 1,
                products: 1,
                roles: 1,
              },
              customColumns: [
                {
                  fieldName: 'name',
                },
                {
                  fieldName: 'url',
                  columnName: 'LamaPoll Link',
                },
                {
                  fieldName: 'showClass',
                  columnName: 'Sichtbar für',
                },
                {
                  fieldName: 'products',
                  columnName: 'Produkte',
                },
                {
                  fieldName: 'studentType',
                  columnName: 'Studenten',
                },
                {
                  fieldName: 'roles',
                  columnName: 'Rollen',
                },
                {
                  fieldName: 'public',
                  columnName: 'Veröffentlicht',
                },
                {
                  fieldName: 'mapping',
                  columnName: 'Felder',
                  selectionSet: {
                    mapping: {
                      pollKey: 1,
                      entityField: 1,
                    },
                  },
                  getFieldMapping: e =>
                    e.mapping
                      .map(m => {
                        return `${m.pollKey}=${
                          Object.entries(POLL_ALLOWED_FIELDS).find(([key, value]) => value === m.entityField)?.[0]
                        }`;
                      })
                      .join(', '),
                },
              ],
            }}
            @entry-clicked=${async (e: CustomEvent<{ entity: PollLink }>) => {
              ChromiumDialog.showPopup<void>({
                content: resolve => {
                  return html`<cr-flex padding="lg">
                    ${CWPollEditor({
                      onDone: async () => resolve(),
                      poll: e.detail.entity,
                    })}
                  </cr-flex>`;
                },
              });
            }}
          ></cr-data-view>
        </cr-flex>
        <cr-flex w100 ${css({ height: '100px' })}></cr-flex>
      </cr-flex>
    `;
  }
}
